import { useEffect } from "react";

const appName = "Caravel CMPAS";

export const useAppTitle = (title?: string) =>
  useEffect(() => {
    document.title = title ? `${title} - ${appName}` : appName;
  }, [title]);
